<template>
	<ja-modal ref="modal" :show="false" class="modal-wrapper">
		<content class="welcome-back-modal">
			<div class="inner-avatar">
				<img :src="require(`@/assets/images/Jimmy.png`)" alt="" />
			</div>
			<div v-if="userData">
				<h1>{{ $t('welcomeBack') }} {{ userData.firstName }},</h1>
			</div>
			<div class="body-text-1 session-expire-text">
				{{ $t('welcomeBackText', { account: userData.email }) }}
			</div>
			<div class="button-wrapper">
				<ja-button
					class="confirm-button large"
					name="confirm-proceed-session"
					@click.native="proceedSession"
					>{{ $t('proceed') }}</ja-button
				>

				<ja-button
					class="cancel-button large transparent outlined"
					name="confirm-logout-session"
					@click.native="logoutSession"
					>{{ $t('relogin') }}</ja-button
				>
			</div>
		</content>
	</ja-modal>
</template>
<script>
import ModalEvents from '@/mixins/ModalEvents';
import Modal from './Modal';
import Button from '../ui/Button';
import UserData from '@/mixins/UserData';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button
	},
	mixins: [UserData, ModalEvents],
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			avatar: null,
			activeConnections: 0
		};
	},
	computed: {
		sinceDate() {
			const now = Date.now();
			const simDate = new Date(this.userData.lastSimulationPlayedDate);
			const sinceInMilliseconds = now - simDate;

			let result = '';
			if (!isNaN(sinceInMilliseconds)) {
				const sinceInSeconds = Math.floor(sinceInMilliseconds / 1000);
				const sinceInMinutes = Math.floor(sinceInSeconds / 60);
				const sinceInHours = Math.floor(sinceInMinutes / 60);
				const sinceInDays = Math.floor(sinceInHours / 60);

				if (sinceInDays > 0) {
					result = `${sinceInDays} ${this.$tc(
						'welcomeBackSinceDays',
						sinceInDays
					)}`;
				} else if (sinceInHours > 0) {
					result = `${sinceInHours} ${this.$tc(
						'welcomeBackSinceHours',
						sinceInHours
					)}`;
				} else if (sinceInMinutes > 1) {
					result = `${sinceInMinutes} ${this.$tc(
						'welcomeBackSinceMinutes',
						sinceInMinutes
					)}`;
				} else {
					result = this.$t('welcomeBackSinceNow');
				}
			}

			return result;
		}
	},
	methods: {
		proceedSession() {
			this.$store.commit('setSkipWelcomeBack', true);
			this.$store.commit('setShowWelcomeBack', false);
			// Two times should be called this because JASA returns wrong cookie time first time.
			this.$store.dispatch('keepSessionAlive').then(() => {
				this.$store.dispatch('keepSessionAlive');
			});
		},
		logoutSession() {
			this.$store.commit('setShowWelcomeBack', false);
			this.$store.dispatch('logoutSingleSession');
		}
	}
};
</script>
<style lang="scss" scoped>
.modal-wrapper {
	z-index: 1001;
	.welcome-back-modal {
		padding: 64px 70px;

		h1 {
			margin: 0;
			margin-top: 14px;
		}

		h5 {
			margin: 8px 0;
		}

		.inner-avatar {
			position: relative;
			top: -125px;
			margin-bottom: -120px;
			background-color: #ffffff;
			border-radius: 50%;
			border: 4px solid #e7f8ff;
			width: 110px;
			height: 110px;

			img {
				width: 100px;
			}
		}
		.session-expire-text {
			margin-top: 15px;
			margin-bottom: 24px;
		}

		.cancel-button,
		.confirm-button {
			margin-top: 48px;
		}

		.cancel-button {
			margin-left: 16px;
		}
	}
}
</style>
